import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChatChamado from './ContentChatChamado';

const ChatChamado = () => {
  return (
    <>
      <Header />
      <ContentChatChamado />
      <Bottom />
    </>
  );
};

export default ChatChamado;
